import { Layout } from "../../UI/Layout/Layout.tsx";
import { NavBar } from "../../UI/Layout/NavBar.tsx";
import { Footer } from "../../UI/Layout/Footer.tsx";
import { FullPageLoading } from "../../UI/FullPageLoading.tsx";
import { useNavigate } from "react-router";
import { AdminMainContainer } from "../../UI/Admin/AdminMainContainer.tsx";
import { useCreateNormasTeachingBundle } from "../../ProductService/NormasTeachingBundle/useCreateNormasTeachingBundle.ts";
import { useAllNormasTeachingProducts } from "../../ProductService/NormasTeachingProduct/useAllNormasTeachingProducts.ts";
import { AdminAllNormasTeachingBundleScreenPath } from "./AdminAllNormasTeachingBundleScreen.tsx";
import {
  CreateNormasTeachingBundleForm,
  CreateNormasTeachingBundleFormValues,
} from "./CreateNormasTeachingBundleForm.tsx";
import { useKnownPurchaseAcTags } from "../../ProductService/useKnownPurchaseAcTags.ts";
import { useKnownRefundAcTags } from "../../ProductService/useKnownRefundAcTags.ts";
import { useKnownAnalyticsTags } from "../../ProductService/useKnownAnalyticsTags.ts";

export const CreateNormasTeachingBundleScreenPath =
  "/admin/normasteaching/create-bundle";
export function CreateNormasTeachingBundleScreen() {
  const { isLoading: isLoadingPurchaseTags, purchaseTags } =
    useKnownPurchaseAcTags("bundles");
  const { isLoading: isLoadingRefundTags, refundTags } =
    useKnownRefundAcTags("bundles");
  const { isLoading: isLoadingAnalyticsTags, analyticsTags } =
    useKnownAnalyticsTags("bundles");

  const { products, isLoading: isLoadingProducts } =
    useAllNormasTeachingProducts();

  const { createNormasTeachingBundle, loading: creating } =
    useCreateNormasTeachingBundle();

  const navigate = useNavigate();

  const loading =
    isLoadingPurchaseTags ||
    isLoadingRefundTags ||
    isLoadingProducts ||
    isLoadingAnalyticsTags;

  const onSubmit = async (
    data: CreateNormasTeachingBundleFormValues,
  ): Promise<void> => {
    await createNormasTeachingBundle({
      bundleName: data.bundleName,
      variantBundleName: data.variantBundleName,
      priceInCents: { amount: data.priceInEuros * 100, currency: "EUR" },
      purchaseAcTags: data.purchaseAcTags ?? [],
      refundAcTags: data.refundAcTags ?? [],
      bundleProducts: data.bundleProducts.map((bundle) => ({
        products: bundle.products.map((product) => ({
          id: product.id,
          priceInCents: {
            amount: product.priceInEuros * 100,
            currency: "EUR",
          },
        })),
      })),
      analyticsTag: data.analyticsTag,
      stripeConfig: data.stripeConfig,
      heylightConfig: data.heylightConfig,
      bundleDescription: data.bundleDescription,
      isCouponEnabled: data.isCouponEnabled,
    });
    navigate(AdminAllNormasTeachingBundleScreenPath);
  };

  if (loading) return <FullPageLoading />;

  return (
    <Layout>
      <AdminMainContainer>
        <NavBar showAdminSideBarHandle />
        <div className={"p-4 flex-1 flex items-center"}>
          <div
            className={
              "max-w-[1024px]  w-full mx-auto bg-white p-4 rounded-lg flex flex-col gap-4"
            }
          >
            <h1 className={"font-bold text-2xl"}>Crea Bundle di prodotti</h1>
            <CreateNormasTeachingBundleForm
              onSubmit={onSubmit}
              products={products}
              creating={creating}
              initialKnownPurchaseAcTags={purchaseTags}
              initialKnownRefundAcTags={refundTags}
              initialKnownAnalyticsTags={analyticsTags}
            />
          </div>
        </div>
      </AdminMainContainer>
      <Footer />
    </Layout>
  );
}
